import api from '../../api/client';
import React from "react";
import StockTransactionPage from "../../components/StockTransactionPage";

const InventoryReport = () => {
  return (
    <>
      <StockTransactionPage />
    </>
  );
};

export default InventoryReport;
